import React from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarContent,
} from "react-pro-sidebar";
import { Link } from "react-router-dom";

import userDefaultPerfil from "../../images/perfil2.png";

import { useDispatch, useSelector } from "react-redux";
import { singOut } from "../../redux/auth/actions";
import { withRouter } from "react-router";

const SidebarCarreraSucesion = (props) => {
  const dispatch = useDispatch();
  const userPic = useSelector((store) => store.auth.pic);
  const userN = useSelector((store) => store.auth.name);
  const userId = useSelector((store) => store.auth.id);
  const userType = useSelector((store) => store.auth.userType);

  const onSignOut = (e) => {
    e.preventDefault();
    dispatch(singOut(props));
  };
  return (
    <>
      <ProSidebar
        collapsed={false}
        className={`custom-sidebar ${props.show ? "show-sidebar" : ""}`}
        toggled={"fixed"}
      >
        <SidebarContent style={{ overflowY: "auto" }}>
          <Menu iconShape="square">
            <div className="d-block d-sm-block d-md-none">
              <SubMenu
                title={userN ? userN : null}
                icon={
                  <img
                    src={!!userPic ? userPic : userDefaultPerfil}
                    className="user-pic"
                    alt="Imagen de perfil"
                  />
                }
              >
                <MenuItem>
                  <Link to={`/perfil-usuario/${userId}/${userType}`}>
                    Mi perfil
                  </Link>
                </MenuItem>
                {/* <MenuItem><Link to="Dashboard-Headcount">Dashboard</Link></MenuItem> */}
                {/* <MenuItem style={{ borderBottom: "2px solid white" }}>
                  <Link to={`/perfil-usuario/${userId}`}>Mi perfil</Link>
                </MenuItem> */}
                <div className="row no-gutters"></div>
                <MenuItem
                  icon={<i className="material-icons">notifications</i>}
                >
                  <Link to="/#!">Notificaciones</Link>
                </MenuItem>
                <MenuItem onClick={onSignOut}>Cerrar sesión</MenuItem>
              </SubMenu>
            </div>
            <MenuItem icon={<i className="material-icons">face</i>}>
              <Link to={`/detalle-empleado/${userId}/${userType}`}>
                Ficha de empleado
              </Link>
            </MenuItem>
            <MenuItem icon={<i className="material-icons">folder_shared</i>}>
                <Link to="/sucesion/plan-individal">
                  Plan de carrera individual
                </Link>
              </MenuItem>
            <MenuItem icon={<i className="material-icons">warning</i>}>
              <Link to="/sucesion/tipo-criticidad">
                Tipo Criticidad
              </Link>
            </MenuItem>
            {/* <MenuItem icon={<i className="material-icons">warning_amber</i>}>
              <Link to="/sucesion/criticidad">Criticidad</Link>
            </MenuItem> */}
            <MenuItem icon={<i className="material-icons">percent</i>}>
              <Link to="/sucesion/factores-criticidad">
                Factores de Criticidad
              </Link>
            </MenuItem>
            
            {/* <MenuItem
              icon={<i className="material-icons">pivot_table_chart</i>}
            >
              <Link to="/sucesion/tipo-criticidad">
                Matriz de evaluación de puesto
              </Link>
            </MenuItem> */}
            <MenuItem
              icon={<i className="material-icons">assignment_turned_in</i>}
            >
             <Link to="/sucesion/cursos">
              Cursos
              </Link> 
            </MenuItem>
            <MenuItem icon={<i className="material-icons">engineering</i>}>
             <Link to="/sucesion/cursos-funcion">
              Curso funciones
             </Link>
            </MenuItem>
            <MenuItem
              icon={<i className="material-icons">checklist_rtl</i>}
            >
             <Link to="/sucesion/criterios">
              Criterios
              </Link> 
            </MenuItem>
            <MenuItem
              icon={<i className="material-icons">ballot</i>}
            >
             <Link to="/sucesion/factores-criterios">
              Factores Criterios
              </Link> 
            </MenuItem>
            <MenuItem
              icon={<i className="material-icons">assignment_add</i>}
            >
             <Link to="/sucesion/factores-responsables">
              Factores Responsables
              </Link> 
            </MenuItem>
           
          </Menu>
        </SidebarContent>
      </ProSidebar>
    </>
  );
};

export default withRouter(SidebarCarreraSucesion);
